import React from 'react';
import { ArrowLeft } from 'lucide-react';
interface MobileHeaderProps {
  title: string;
  onBack?: () => void;
  right?: React.ReactNode;
  subtitle?: string;
}
export function MobileHeader({
  title,
  onBack,
  right,
  subtitle
}: MobileHeaderProps) {
  return <header className="flex items-center gap-2 bg-navy-800 px-3 pb-3 pt-2 text-white" data-id="element-787" data-mp="18rcodl86pjg">
      {onBack && <button onClick={onBack} aria-label="ফিরে যান" className="flex h-9 w-9 items-center justify-center rounded-full hover:bg-white/10" data-id="element-788" data-mp="t2balan0gdjz">
          <ArrowLeft className="h-5 w-5" data-id="element-789" data-mp="p1rgkfxqhq22" />
        </button>}
      <div className={`min-w-0 flex-1 ${onBack ? '' : 'pl-1'}`} data-id="element-790" data-mp="k1d5ep0u5zzt">
        <h1 className="truncate font-heading text-base font-semibold" data-id="element-791" data-mp="jzsd761zut54">{title}</h1>
        {subtitle && <p className="truncate text-[11px] text-navy-200" data-id="element-792" data-mp="f2acg2y4rk87">{subtitle}</p>}
      </div>
      {right}
    </header>;
}